import React from 'react';

import ShowcaseGrid from 'src/components/ui/ShowcaseGrid';
import Image from 'src/components/ui/Image';
import Video from 'src/components/ui/Video';

import type { Medium } from 'src/types/__generated__/graphql';
import { MediumType } from 'src/types/__generated__/graphql';

import { defaultAudioImagePath, defaultWoopenImagePath } from 'src/constants/defaultImages';

type PreviewMedia = Array<{
    type: Medium['type'];
    url: Medium['url'];
    isTranscoding?: Medium['isTranscoding'];
} | null>;

type GalleryPreviewImageProps = {
    previewMedia?: PreviewMedia | null;
    showShowcaseGrid: boolean;
};

export const GalleryPreviewImage: React.FC<GalleryPreviewImageProps> = ({ previewMedia, showShowcaseGrid }) => {
    if (showShowcaseGrid) {
        return (
            <ShowcaseGrid
                showcaseMedia={previewMedia}
                height={200}
                borderRadius="1rem"
                minNumberOfMediumToShowGrid={0}
            />
        );
    }

    return previewMedia?.[0] && previewMedia[0].type === MediumType.Video ? (
        <Video
            width={128}
            height={128}
            src={previewMedia[0].url}
            isTranscoding={Boolean(previewMedia[0].isTranscoding)}
            muted
        />
    ) : (
        <Image
            alt="gallery-main-image"
            width={128}
            height={128}
            src={
                previewMedia?.[0] && previewMedia[0].type === MediumType.Audio
                    ? defaultAudioImagePath
                    : previewMedia?.[0]?.url ?? defaultWoopenImagePath
            }
            style={{ objectFit: 'cover' }}
        />
    );
};
